import { Box } from '@mui/material'
import { t } from 'i18next'


const NoMatch = () => {
  return <Box sx={{ marginTop: '120px' }}>404 {t('common.noMatch')}</Box>
}

export default NoMatch
